import PropTypes from 'prop-types';
import React from 'react';

var _ = require('lodash');
const axios = require('axios').default;

import Tags from "@yaireo/tagify/dist/react.tagify";
import AsyncSelect from 'react-select/async';

const selectStyles = {
  container: (base, state) => ({
    ...base,
    opacity: state.isDisabled ? ".5" : "1",
    backgroundColor: "transparent",
    zIndex: "999"
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: provided => ({ ...provided, zIndex: "9999 !important" })
};

const debouncedFetch = _.debounce((inputValue, callback, currentEvent, currentPartnership) => {
  new Promise(resolve => {
    axios.get('/e/' + currentEvent.permalink + '/p/' + currentPartnership.id + '/tags/autocomplete', {
        params: {
          name: inputValue
        }
      })
      .then(function (response) {
        var newOptions = response.data.map(function(data){
          return { value: data.id, label: data.name };
        });

        callback(newOptions);
      })
  });
}, 250);

const PartnershipForm = ({
  csrfToken,
  currentEvent,
  currentPartnership,
  partnership,
  updatePartnershipFirstName,
  updatePartnershipLastName,
  updatePartnershipEmail,
  partnershipChanged,
  organizationNames,
  organizationNamesChanged,
  eventOrganizationPartnershipNames,
  eventHostOrganizationPartnership,
  updatePartnershipHost
}) => {
  const defaultOrganizationName = `${partnership.first_name} ${partnership.last_name}'s Organization`;

  return (
  <div className='row'>
    <div className='col-12'>
      <div className="form-row">
        <div className="col">
          <div className="form-group">
            {partnership.invitation && partnership.invitation.id ? (
              <React.Fragment>
                <input type="hidden"
                       name="partnership[invitation_attributes][id]"
                       value={partnership.invitation.id} />
                <input type="hidden"
                       name="partnership[invitation_attributes][email]"
                       value={partnership.email} />
              </React.Fragment>
            ) : null}
            <label className="form-control-label text-muted"
                   htmlFor="partnership-email">
              Email (No email will be sent) <abbr title="required">*</abbr>
            </label>
            <input className="form-control"
                   type="email"
                   name="partnership[email]"
                   onChange={
                     (e) => {
                       updatePartnershipEmail(e.target.value);
                     }
                   }
                   disabled={partnership.user_id || false}
                   value={partnership.email || ""}
                   id="partnership-email" />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="col">
          <div className="form-group">
            <label className="form-control-label text-muted"
                   htmlFor="partnership-first-name">
              First name <abbr title="required">*</abbr>
            </label>
            <input className="form-control"
                   type="text"
                   name="partnership[first_name]"
                   disabled={partnership.user_id || false}
                   onChange={
                     (e) => {
                       updatePartnershipFirstName(e.target.value);
                     }
                   }
                   value={partnership.first_name || ""}
                   id="partnership-first-name" />
          </div>
        </div>
        <div className="col">
          <div className="form-group">
            <label className="form-control-label text-muted"
                   htmlFor="partnership-last-name">
              Last name <abbr title="required">*</abbr>
            </label>
            <input className="form-control"
                   type="text"
                   name="partnership[last_name]"
                   disabled={partnership.user_id || false}
                   onChange={
                     (e) => {
                       updatePartnershipLastName(e.target.value);
                     }
                   }
                   value={partnership.last_name || ""}
                   id="partnership-last-name" />
          </div>
        </div>
      </div>
      <div className="form-group">
        <div className='d-flex justify-content-between'>
          <label htmlFor="partnership-organization-name"
                className="text-muted">
            Organization <abbr title="required">*</abbr>
          </label>
          <div className="form-check">
            <input className="form-check-input is-valid boolean optional"
                    type="checkbox"
                    value="1"
                    disabled={!partnership.first_name || !partnership.last_name}
                    onChange={
                      (e) => {
                        var updated;

                        if (organizationNames.map((n) => n.value).includes(defaultOrganizationName)) {
                          updated = organizationNames.filter((organizationName) => organizationName.value !== defaultOrganizationName);
                        } else {
                          updated = [...organizationNames, {value: defaultOrganizationName}];
                        }

                        organizationNamesChanged(updated);
                      }
                    }
                    checked={organizationNames.map((n) => n.value).includes(defaultOrganizationName)}
                    id="partnership-add-default-organization" />
            <label className="form-check-label boolean optional text-muted"
                    htmlFor="partnership-add-default-organization">
              Add default organization
            </label>
          </div>
        </div>
        <input type="hidden"
               value=""
               name="partnership[organization_names][]" />
        {organizationNames.map((selected, index) =>
          <input key={index}
                 type="hidden"
                 value={selected.value}
                 name="partnership[organization_names][]" />
        )}
        <Tags placeholder={"Add or find an Organization - REQUIRED UNLESS HOST"}
              className="w-100"
              whitelist={eventOrganizationPartnershipNames}
              onChange={
                (e) => {
                  var options = e.detail.tagify.value;

                  if (options.map((o) => o.value).includes(eventHostOrganizationPartnership.name)) {
                    updatePartnershipHost(true);
                  } else {
                    updatePartnershipHost(false);
                  }

                  organizationNamesChanged(options);
                }
              }
              value={organizationNames} />
      </div>
      <div className="form-group">
        <p style={{ fontSize: '20px' }} className="mb-0">
          Host Settings
        </p>
        <p style={{ fontSize: '14px' }} className="text-muted">
          This section only applies to project hosts
        </p>
        <div className="form-check">
          <input type="hidden"
                  name={"partnership[host]"}
                  value={partnership.host ? "1" : "0"} />
            <input className="form-check-input is-valid boolean optional"
                    type="checkbox"
                    disabled={!partnership.first_name || !partnership.last_name}
                    onChange={
                      (e) => {
                        var updated;

                        if (organizationNames.map((n) => n.value).includes(eventHostOrganizationPartnership.name)) {
                          updated = organizationNames.filter((organizationName) => organizationName.value !== eventHostOrganizationPartnership.name);
                        } else {
                          updated = [...organizationNames, {value: eventHostOrganizationPartnership.name}];
                        }

                        organizationNamesChanged(updated);

                        var updatedPartnership = Object.assign({}, partnership, {
                          host: e.target.checked
                        });
                        partnershipChanged(updatedPartnership);
                      }
                    }
                    checked={organizationNames.map((n) => n.value).includes(eventHostOrganizationPartnership.name)}
                    id="partnership-host" />
          <label className="form-check-label boolean optional text-muted"
                  htmlFor="partnership-host">
            This person can access the Host dashboard for this project
          </label>
        </div>
        {partnership.host ? (
          <span>
            <div className="form-check">
              <input type="hidden"
                      name={"partnership[read_only]"}
                      value={partnership.read_only ? "1" : "0"} />
              <input className="form-check-input is-valid boolean optional"
                      type="checkbox"
                      onChange={
                        (e) => {
                          var updated = Object.assign({}, partnership, {
                            read_only: e.target.checked
                          });
                          partnershipChanged(updated);
                        }
                      }
                      checked={partnership.read_only || false}
                      disabled={!partnership.first_name || !partnership.last_name}
                      id="partnership-read-only" />
              <label className="form-check-label boolean optional text-muted"
                      htmlFor="partnership-read-only">
                This host is a read-only observer
              </label>
            </div>
            <div className="form-check">
              <input type="hidden"
                      name={"partnership[notify_for_completed_tasks]"}
                      value={partnership.notify_for_completed_tasks ? "1" : "0"} />
              <input className="form-check-input is-valid boolean optional"
                      type="checkbox"
                      onChange={
                        (e) => {
                          var updated = Object.assign({}, partnership, {
                            notify_for_completed_tasks: e.target.checked
                          });
                          partnershipChanged(updated);
                        }
                      }
                      checked={partnership.notify_for_completed_tasks || false}
                      disabled={!partnership.first_name || !partnership.last_name}
                      id="partnership-notify-for-completed-tasks" />
              <label className="form-check-label boolean optional text-muted"
                      htmlFor="partnership-notify-for-completed-tasks">
                Notify host via email when a task is completed
              </label>
            </div>
            <div className="form-check">
              <input type="hidden"
                      name={"partnership[notify_for_self_registrations]"}
                      value={partnership.notify_for_self_registrations ? "1" : "0"} />
              <input className="form-check-input is-valid boolean optional"
                      type="checkbox"
                      onChange={
                        (e) => {
                          var updated = Object.assign({}, partnership, {
                            notify_for_self_registrations: e.target.checked
                          });
                          partnershipChanged(updated);
                        }
                      }
                      checked={partnership.notify_for_self_registrations || false}
                      disabled={!partnership.first_name || !partnership.last_name}
                      id="partnership-notify-for-self-registrations" />
              <label className="form-check-label boolean optional text-muted"
                      htmlFor="partnership-notify-for-self-registrations">
                Notify host via email when a new self registration is created
              </label>
            </div>
            {currentPartnership.owner ? (
              <div className="form-check">
                <input type="hidden"
                        name={"partnership[can_edit_permissions]"}
                        value={partnership.can_edit_permissions ? "1" : "0"} />
                <input className="form-check-input is-valid boolean optional"
                        type="checkbox"
                        onChange={
                          (e) => {
                            var updated = Object.assign({}, partnership, {
                              can_edit_permissions: e.target.checked
                            });
                            partnershipChanged(updated);
                          }
                        }
                        checked={partnership.can_edit_permissions || false}
                        disabled={!partnership.first_name || !partnership.last_name}
                        id="partnership-can-edit-permissions" />
                <label className="form-check-label boolean optional text-muted"
                        htmlFor="partnership-can-edit-permissions">
                  This host can access permission settings
                </label>
              </div>
            ) : null}
          </span>
        ) : null}
      </div>
    </div>
  </div>
  );
};

PartnershipForm.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  currentEvent: PropTypes.object.isRequired,
  currentPartnership: PropTypes.object.isRequired,
  partnership: PropTypes.object.isRequired,
  updatePartnershipFirstName: PropTypes.func.isRequired,
  updatePartnershipLastName: PropTypes.func.isRequired,
  updatePartnershipEmail: PropTypes.func.isRequired,
  partnershipChanged: PropTypes.func.isRequired,
  organizationNames: PropTypes.array,
  organizationNamesChanged: PropTypes.func.isRequired,
  eventOrganizationPartnershipNames: PropTypes.array,
  eventHostOrganizationPartnership: PropTypes.object.isRequired,
  updatePartnershipHost: PropTypes.func.isRequired
};

export default PartnershipForm;
